import React from "react";
// import Container from "../components/Layouts/Container"; 
import UpdateProfile from "../components/Profile/UpdateProfile";

const UpdateProfilePage = () => {
  return (
    // <Container>
      <UpdateProfile />
    // </Container>
  );
};

export default UpdateProfilePage;
